import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass/styled-components';

export const CardShadow = ({ dragging }) => (
  <Box
    height={dragging.height}
    bg="neutral.50"
    sx={{
      flexShrink: 0,
      borderRadius: 'default',
    }}
  />
);

CardShadow.propTypes = {
  dragging: PropTypes.object.isRequired,
};
